import React, { useEffect, useRef, useState } from "react";
import Alert from "./components/Alert";
import Api from "./components/api/api";
import CategoriesSelect from "./components/CategoriesSelect";
import Footer from "./components/Footer";
import Header from "./components/Header";
import HistoryPopup from "./components/HistoryPopup";
import Loading from "./components/Loading";
import Menu from "./components/Menu";
import Products from "./components/Products";
import Shops from "./components/Shops";
import Tables from "./components/Tables";
import Toast from "./components/Toast";
import VariantsPopup from "./components/VariantsPopup";
import Login from "./components/Login";
import OrderNotes from "./components/OrderNotes";
import ProductNotes from "./components/ProductNotes";
import Covers from "./components/Covers";
import FlowModeSelector from "./components/FlowModeSelector";
import PriceEditPopup from "./components/PriceEditPopup";
import Settings from "./components/Settings";
import moment from "moment/moment";
import { io } from "socket.io-client";
import { jwtDecode } from "jwt-decode";
import "./css/App.css";
import "./css/Popup.css";
import "./css/Menu.css";
import "./css/Login.css";
import "./css/MenuCategories.css";
import Socket from "./Socket";
import Cart from "./components/Cart";
import TableEditPopup from "./components/TableEditPopup";
import QrPopup from "./components/QrPopup";
import { useAppStore } from "./useAppStore";
import { adaptMenuFlat } from "./menu/MenuFlatAdapter";
import { getSelectedVariantItems, normalizeSelectedVariants } from "./utilities/selectedVariants";
import { isTabletEmbed, embedShopId, requestEmbedToken, postToParent } from "./embed";

export const MainContext = React.createContext();

let socketUrl = getSocketUrl();
console.log("socketUrl", socketUrl);
const socket = io(socketUrl);

function App() {
  const queryParams = new URLSearchParams(window.location.search);
  const [settings, setSettings] = useState(false);
  const [loading, setLoading] = useState(false);
  const [alertData, setAlertData] = useState(false);
  const [popupData, setPopupData] = useState(false);
  const [shop, setShop] = useState(false);
  const [table, setTable] = useState(false);
  const [list, setList] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [popupVisible, setPopupVisible] = useState(false);
  const [cart, setCart] = useState(false);
  const [variantsPopup, setVariantsPopup] = useState(false);
  const [toast, setToast] = useState(false);
  const [menuVisible, setMenuVisible] = useState(false);
  const [user, setUser] = useState(false);
  const [config, setConfig] = useState(
    localStorage.getItem("waiter-config") ? JSON.parse(localStorage.getItem("waiter-config")) : false,
  );
  const [tables, setTables] = useState([]);
  const [rooms, setRooms] = useState([]);
  const [menu, setMenu] = useState(false);
  const [courses, setCourses] = useState(false);
  const [category, setCategory] = useState(false);
  const [flow, setFlow] = useState(1);
  const [maxFlow, setMaxFlow] = useState(5);
  const [cartVisible, setCartVisible] = useState(false);
  const [animations, setAnimations] = useState([]);
  const [tempTable, setTempTable] = useState(false);
  const [lists, setLists] = useState([]);
  const [tableEditPopup, setTableEditPopup] = useState(false);
  const [ordersDisabled, setOrdersDisabled] = useState(false);
  const [shops, setShops] = useState(false);
  const [dismissedLicenseNotice, setDismissedLicenseNotice] = useState(false);
  const [qrPopupVisible, setQrPopupVisible] = useState(false);
  const [qrPopupCloseToTables, setQrPopupCloseToTables] = useState(false);
  const [stock, setStock] = useState([]);
  const [thermalPrinters, setThermalPrinters] = useState([]);
  const [waiterSettings, setWaiterSettings] = useState(false);
  const tablesLoadingRef = useRef(false);
  const prevShopIdRef = useRef(null);
  const tablesQueuedRef = useRef(false);
  const orderSubmitInFlightRef = useRef(false);
  const { src } = useAppStore();
  const getBaseFlowsNumber = () => Math.max(parseInt(settings?.orders?.flows_number || 5), 1);

  useEffect(() => {
    console.log("Migration test 1");
    init();
  }, []);

  useEffect(() => {
    if (!shops) return;
    // embed tablet: il negozio lo decide il genitore, nessuna scelta/persistenza locale
    const savedShopId = isTabletEmbed ? embedShopId : localStorage.getItem("waiter-shop-id");
    const savedShop = savedShopId ? shops.find((s) => parseInt(s.id) === parseInt(savedShopId)) : false;
    if (savedShop) {
      setShop(savedShop);
      return;
    }
    if (shops.length === 1) {
      setShop(shops[0]);
      return;
    }
    setShop(false);
  }, [shops]);

  useEffect(() => {
    if (shop) {
      loadLists();
      loadThermalPrinters();
      if (!isTabletEmbed) localStorage.setItem("waiter-shop-id", shop.id);
      if (prevShopIdRef.current !== null && prevShopIdRef.current !== shop.id) {
        setWaiterSettings({});
      } else {
        const savedSettings = localStorage.getItem("waiter-settings-" + shop.id);
        setWaiterSettings(savedSettings ? JSON.parse(savedSettings) : {});
      }
      prevShopIdRef.current = shop.id;
    }
  }, [shop]);

  useEffect(() => {
    if (shop && waiterSettings) {
      localStorage.setItem("waiter-settings-" + shop.id, JSON.stringify(waiterSettings));
    }
  }, [waiterSettings, shop]);

  useEffect(() => {
    console.log("table set to", table);
    if (table) setList(table.list_id ? { id: table.list_id } : false);
  }, [table]);

  useEffect(() => {
    console.log("list set to", list);
  }, [list]);

  useEffect(() => {
    console.log("cart set to", cart);
  }, [cart]);

  useEffect(() => {
    console.log("tempTable set to", tempTable);
  }, [tempTable]);

  useEffect(() => {
    if (menu) filterMenu();
  }, [menu, list, shop, settings, stock]);

  useEffect(() => {
    if (table) {
      const nextTable = tables.find((t) => t.id == table.id);
      if (nextTable) setTable(nextTable);
    }
    if (tempTable) {
      const nextTempTable = tables.find((t) => t.id == tempTable.id);
      if (nextTempTable) setTempTable(nextTempTable);
    }
  }, [tables]);

  useEffect(() => {
    if (user) loadData();
  }, [user]);

  useEffect(() => {
    if (user) return;
    // Reset UI context on logout to always re-enter from tables flow after next login.
    setTable(false);
    setTempTable(false);
    setCartVisible(false);
    setTableEditPopup(false);
    setPopupVisible(false);
    setVariantsPopup(false);
    setMenuVisible(false);
    setQrPopupVisible(false);
    setQrPopupCloseToTables(false);
    setFlow(1);
  }, [user]);

  const closeQrPopup = () => {
    setQrPopupVisible(false);
    if (qrPopupCloseToTables) {
      setTable(false);
    }
    setQrPopupCloseToTables(false);
  };

  useEffect(() => {
    if (settings) {
      setOrdersDisabled(
        isTabletEmbed || queryParams.get("disable_orders") == 1 || settings.mandant.disable_orders == 1,
      );
      setMaxFlow((prev) => Math.max(parseInt(prev || 0), getBaseFlowsNumber()));
    }
  }, [settings]);

  useEffect(() => {
    console.log(
      "ordersDisabled set to",
      ordersDisabled,
      queryParams.get("disable_orders"),
      settings?.mandant?.disable_orders,
    );
  }, [ordersDisabled]);

  async function init() {
    console.log("init");

    Api.setBaseUrl(config);
    await load_settings();
    if (isTabletEmbed) startEmbedLogin();
    else await restoreUser();

    setLoaded(true);
  }

  // embed tablet: il token operatore arriva dal selforder via postMessage (vedi embed.js).
  // "ready" viene ripetuto finché il genitore non risponde, perché potrebbe non essere ancora in ascolto.
  function startEmbedLogin() {
    let done = false;
    let timer = null;
    const stop = requestEmbedToken(async (token) => {
      if (done) return;
      done = true;
      clearInterval(timer);
      stop();
      Api.setToken(token);
      const decoded = jwtDecode(token);
      const response = await Api.getProtected("/users/get/" + decoded.user_id + "/");
      if (response.success == 0) alert(response.error);
      else setUser(response.data);
    });
    timer = setInterval(() => postToParent({ type: "ready" }), 1000);
  }

  async function loadData() {
    console.log("loadData");
    setLoaded(false);
    await loadMenu();
    await loadShops();
    await loadRooms();
    await loadTables();
    await loadStock();
    setLoaded(true);
  }

  async function restoreUser() {
    if (queryParams.get("user_id")) {
      const id = queryParams.get("user_id");
      const refresh = await Api.autoLogin(id);
      if (refresh.success == 0) alert(refresh.error);
      else {
        localStorage.setItem("waiter-user", refresh.token);
        const decoded = jwtDecode(refresh.token);
        const response = await Api.getProtected("/users/get/" + decoded.user_id + "/");
        if (response.success == 0) alert(response.error);
        else setUser(response.data);
      }
    } else {
      const token = localStorage.getItem("waiter-user");
      if (token) {
        const refresh = await Api.refreshToken(token);
        if (refresh.success == 0) alert(refresh.error);
        else {
          localStorage.setItem("waiter-user", refresh.token);
          const decoded = jwtDecode(refresh.token);
          const response = await Api.getProtected("/users/get/" + decoded.user_id + "/");
          if (response.success == 0) alert(response.error);
          else setUser(response.data);
        }
      }
    }
  }

  async function openOrder(order) {
    console.log("openOrder");
    setLoading(true);
    const response = await Api.getProtected("/orders/get/" + order.id + "/");
    setLoading(false);
    if (response.success == 0) {
      alert(response.error);
    } else {
      const data = response.data;
      console.log(data);
      const newCart = {
        order_id: data.id,
        notes: data.notes,
        products: data.products.map((p) => openProduct(p)),
      };
      console.log(newCart);
      setCart(newCart);
      const maxProductFlow = Math.max(0, ...newCart.products.map((p) => parseInt(p.flow || 0)));
      setMaxFlow(Math.max(getBaseFlowsNumber(), maxProductFlow));
      setFlow(1);
      setTable(tempTable);
      setTableEditPopup(false);
      setPopupVisible(false);
      setCartVisible(true);
    }
  }

  const openProduct = (p) => {
    console.log("openProduct");
    return {
      ...findProductById(p.product_id),
      ...{
        item_id: p.id,
        qty: p.qty,
        price: p.price,
        notes: p.notes,
        flow: p.flow,
        selectedVariants: p.variants
          .map((v) => ({
            id: v.variants_category.id,
            name: v.variants_category.name,
            tot: v.qty,
            variants: [
              {
                id: v.variant_id,
                name: v.name,
                qty: v.qty,
                price: v.price,
              },
            ],
            variants2: [],
            products: [],
            products2: [],
          }))
          .concat(
            p.products.map((v) => ({
              id: v.variants_category.id,
              name: v.variants_category.name,
              tot: v.qty,
              variants: [],
              variants2: [],
              products: [
                {
                  id: v.variant_id,
                  name: v.name,
                  qty: v.qty,
                  price: v.price,
                },
              ],
              products2: [],
            })),
          ),
        selectedIngredients: [],
      },
    };
  };

  function findProductById(productId) {
    console.log("findProductById");
    for (const course of courses) {
      if (!course.categories) continue;

      for (const category of course.categories) {
        if (!category.products) continue;

        for (const product of category.products) {
          if (product.id === productId) {
            return product;
          }
        }
      }
    }
    return null;
  }

  async function initCart(initialProducts = []) {
    console.log("initCart");
    setCart({ notes: null, products: initialProducts });
    setMaxFlow(getBaseFlowsNumber());
  }

  async function load_settings() {
    console.log("load_settings");
    const response = await Api.post("/settings2/get/", {
      section: ["global", "orders", "waiter_app", "menu_api", "selfordering"],
    });
    setSettings(response.data);

    document.title = "APP Cameriere | " + response.data.global.name;
  }

  async function loadThermalPrinters() {
    console.log("loadThermalPrinters");
    const response = await Api.postProtected("/thermal_printers/list/", {
      src: [
        { name: "active", value: 1, compare: "equal" },
        { name: "shop_id", value: shop.id, compare: "equal" },
      ],
    });
    if (response.success == 0) return;
    setThermalPrinters(response.rows);
  }

  const loadMenu = async () => {
    console.log("loadMenu");
    const flatResponse = await Api.get("/menu/courses_flat/");
    if (flatResponse.success === 0 || !flatResponse.data) {
      alert(flatResponse.error || "Errore nel caricamento del menu");
      return;
    }

    try {
      const adaptedMenu = adaptMenuFlat(flatResponse);
      setMenu(adaptedMenu.menu);
    } catch (error) {
      console.error("menu_flat adapt failed", error);
      alert("Errore nel parsing del menu");
    }
  };

  const loadLists = async () => {
    console.log("loadLists");
    setLoading(true);
    const response = await Api.postProtected("/waiters_app/lists/", {
      shop_id: shop.id,
    });
    setLoading(false);
    setLists(response.rows);
  };

  const loadShops = async () => {
    console.log("loadShops");
    const response = await Api.post("/shops/list/", {
      orderby: "position",
      fields: ["id", "name", "selfordering_pin", "license_expires_at"],
      depth: 0,
      src: [
        {
          name: "active",
          value: 1,
          compare: "equal",
        },
      ],
    });
    let availableShops = response.rows || [];
    const isAdmin = parseInt(user?.role?.admin) === 1;
    if (!isAdmin) {
      const allowedShopIds = new Set(
        (Array.isArray(user?.shops) ? user.shops : [])
          .map((s) => parseInt(s.id))
          .filter((id) => !Number.isNaN(id)),
      );
      if (allowedShopIds.size > 0) {
        availableShops = availableShops.filter((s) => allowedShopIds.has(parseInt(s.id)));
      } else if (user?.shop_id) {
        availableShops = availableShops.filter((s) => parseInt(s.id) === parseInt(user.shop_id));
      } else {
        availableShops = [];
      }
    }
    setShops(availableShops);
  };

  const loadRooms = async () => {
    console.log("loadRooms");
    const response = await Api.postProtected("/waiters_app/rooms/", {
      fields: ["id", "name"],
    });
    setRooms(response.rows);
  };

  const loadTables = async () => {
    if (tablesLoadingRef.current) {
      tablesQueuedRef.current = true;
      return;
    }

    tablesLoadingRef.current = true;
    console.log("loadTables");
    try {
      const response = await Api.postProtected("/waiters_app/tables/");
      if (response.success == 0) alert(response.error);
      else setTables(response.rows);
      setLoading(false);
    } catch (error) {
      alert(error.message);
    } finally {
      tablesLoadingRef.current = false;
      if (tablesQueuedRef.current) {
        tablesQueuedRef.current = false;
        loadTables();
      }
    }
  };

  const loadStock = async () => {
    console.log("loadStock");
    const response = await Api.postProtected("/products_stock/list_for_clients/");
    setLoading(false);
    if (response.success == 1) {
      setStock(response.rows);
    } else alert(response.error);
  };

  const buildDefaultSelectedVariantsForProduct = (product) => {
    const categories = Array.isArray(product?.variants_categories) ? product.variants_categories : [];
    return categories.map((variantsCategory) => {
      const variants = (variantsCategory.variants || []).map((variant) => ({
        id: variant.id,
        name: variant.name,
        qty: 0,
        price: variant.price,
      }));
      const variants2 = (variantsCategory.variants2 || []).map((variant) => ({
        id: variant.id,
        name: variant.name,
        qty: variant.is_default > 0 ? 1 : 0,
        price: variant.price,
      }));
      const products = (variantsCategory.products || []).map((subproduct) => ({
        id: subproduct.id,
        name: subproduct.name,
        qty: 0,
        price: subproduct.price,
      }));
      const products2 = (variantsCategory.products2 || []).map((subproduct) => ({
        id: subproduct.id,
        name: subproduct.name,
        qty: subproduct.is_default > 0 ? 1 : 0,
        price: subproduct.price,
      }));
      const defaultTot =
        variants.reduce((sum, item) => sum + (parseInt(item.qty) || 0), 0) +
        variants2.reduce((sum, item) => sum + (parseInt(item.qty) || 0), 0) +
        products.reduce((sum, item) => sum + (parseInt(item.qty) || 0), 0) +
        products2.reduce((sum, item) => sum + (parseInt(item.qty) || 0), 0);

      return {
        id: variantsCategory.id,
        name: variantsCategory.name,
        force_mono: variantsCategory.force_mono || 0,
        tot: defaultTot,
        variants,
        variants2,
        products,
        products2,
      };
    });
  };

  const buildDefaultSelectedIngredientsForProduct = (product) =>
    (product?.ingredients || []).map((ingredient) => ({
      id: ingredient.id,
      name: ingredient.name,
      selected: true,
    }));

  const hasRequiredVariants = (product) => {
    const categories = Array.isArray(product?.variants_categories) ? product.variants_categories : [];
    return categories.some((variantsCategory) => {
      const min = parseInt(variantsCategory?.min || 0) || 0;
      if (min <= 0) return false;
      const optionsCount =
        (variantsCategory?.variants?.length || 0) +
        (variantsCategory?.variants2?.length || 0) +
        (variantsCategory?.products?.length || 0) +
        (variantsCategory?.products2?.length || 0);
      return optionsCount > 0;
    });
  };

  const handleAddProduct = (product, variants = false, ingredients = false, flow = false, note = "") => {
    console.log("handleAddProduct");
    if (product.stock === false || getCartQty(product.id) < product.stock) {
      if (variants === false && hasRequiredVariants(product)) {
        setVariantsPopup({
          product: { ...product, notes: note || product.notes || "" },
          index: false,
        });
      } else {
        const defaultVariants =
          variants !== false
            ? variants
            : (product?.variants_categories || []).length > 0
              ? buildDefaultSelectedVariantsForProduct(product)
              : false;
        const defaultIngredients =
          ingredients !== false
            ? ingredients
            : (product?.ingredients || []).length > 0
              ? buildDefaultSelectedIngredientsForProduct(product)
              : false;

        addProduct(product, defaultVariants, defaultIngredients, flow, note);
        setVariantsPopup(false);
      }
    }
  };

  const getCartQty = (productId) => {
    let count = 0;
    for (const p of cart.products) {
      if (productId == p.id) count += p.qty;
    }
    return count;
  };

  const addProduct = (product, selectedVariants, selectedIngredients, requestedFlow, note = "") => {
    console.log("addProduct");
    product.qty = 1;
    product.flow = requestedFlow ? requestedFlow : flow;
    product.selectedVariants = selectedVariants;
    product.selectedIngredients = selectedIngredients;
    product.notes = note || "";
    let tempCart = { ...cart };
    const pIndex = checkIfProductExist(tempCart.products, product, product.flow);
    console.log("pIndex", pIndex);
    if (pIndex === false) {
      tempCart.products.push({ ...product });
    } else {
      tempCart.products[pIndex].qty++;
    }
    setCart(tempCart);
    setAnimations([...animations, product.id]);
  };

  const saveProduct = (productIndex, product) => {
    console.log("saveProduct");
    let tempCart = { ...cart };
    tempCart.products[productIndex] = product;
    setCart(tempCart);
    setVariantsPopup(false);
  };

  const editQty = (productIndex, type) => {
    console.log("editQty");
    let tempCart = { ...cart };
    setAnimations([...animations, tempCart.products[productIndex].id]);
    if (type == "plus") {
      const stock = getLiveStock(tempCart.products[productIndex].id);
      if (stock === false || getCartQty(tempCart.products[productIndex].id) < stock)
        tempCart.products[productIndex].qty++;
    } else {
      tempCart.products[productIndex].qty--;
      if (tempCart.products[productIndex].qty <= 0) tempCart.products.splice(productIndex, 1);
    }
    setCart(tempCart);
  };

  const getLiveStock = (productId) => {
    for (const c of courses) {
      for (const cat of c.categories) {
        for (const p of cat.products) {
          if (p.id == productId) return p.stock;
        }
      }
    }
    return false;
  };

  const editFlow = (productIndex, type) => {
    console.log("editFlow");
    let tempCart = { ...cart };
    if (type == "plus") tempCart.products[productIndex].flow++;
    else {
      tempCart.products[productIndex].flow--;
    }
    setCart(tempCart);
  };

  const emptyCart = () => {
    console.log("emptyCart");
    let tempCart = { ...cart };
    tempCart.products = [];
    tempCart.notes = null;
    setCart(tempCart);
  };

  const checkout = async () => {
    console.log("checkout");
    if (orderSubmitInFlightRef.current) return;
    orderSubmitInFlightRef.current = true;
    try {
      setLoading(true);

      const stockCheck = await Api.postProtected("/products_stock/check/", {
        shop_id: shop.id,
        products: cart.products,
      });
      if (stockCheck.success == 0) {
        setAlertData({
          title: "Errore",
          message: stockCheck.error,
        });
        return;
      }

      let ordersSessionId = table.cart_id;
      console.log(ordersSessionId);

      let tempCart = { ...cart };

      let request = {
        delivery_type: "shop",
        delivery_date: moment().format("YYYY-MM-DD HH:mm:ss"),
        status: table.room.waiter_order_status || "confirmed",
        total: 0,
        origin: "waiter",
        shop_id: shop.id,
        list_id: list ? list.id : null,
        room_id: table.room_id,
        table_id: table.id,
        user_id: user.id,
        self_cart_id: ordersSessionId,
        notes: tempCart.notes,
        products: [],
        covers: table.covers,
      };

      for (const p of tempCart.products) {
        let product = {
          product_id: p.id,
          name: p.name,
          qty: p.qty,
          price: parseFloat(p.price),
          flow: p.flow,
          notes: p.notes,
          variants: [],
          products: [],
        };
        if (p.selectedVariants !== false) {
          for (const vc of normalizeSelectedVariants(p.selectedVariants)) {
            for (const v of getSelectedVariantItems(vc, "variants")) {
              if (v.qty > 0) {
                let variant = {
                  variant_category_id: vc.id,
                  variant_id: v.id,
                  name: v.name,
                  qty: v.qty,
                  price: v.price,
                };
                product.variants.push(variant);
                product.price += parseFloat(v.price) * parseInt(v.qty);
              }
            }
            for (const v of getSelectedVariantItems(vc, "variants2")) {
              if (v.qty > 0 || vc.force_mono == 1) {
                let variant = {
                  variant_category_id: vc.id,
                  variant_id: v.id,
                  name: v.name,
                  qty: v.qty,
                  price: v.price,
                };
                product.variants.push(variant);
                product.price += parseFloat(v.price) * parseInt(v.qty);
              }
            }
            for (const v of getSelectedVariantItems(vc, "products")) {
              if (v.qty > 0) {
                let variant = {
                  variant_category_id: vc.id,
                  product_id: v.id,
                  name: v.name,
                  qty: v.qty,
                  price: v.price,
                };
                product.products.push(variant);
                product.price += parseFloat(v.price) * parseInt(v.qty);
              }
            }
            for (const v of getSelectedVariantItems(vc, "products2")) {
              if (v.qty > 0) {
                let variant = {
                  variant_category_id: vc.id,
                  product_id: v.id,
                  name: v.name,
                  qty: v.qty,
                  price: v.price,
                };
                product.products.push(variant);
                product.price += parseFloat(v.price) * parseInt(v.qty);
              }
            }
          }
        }
        if (Array.isArray(p.selectedIngredients)) {
          for (const i of p.selectedIngredients) {
            if (!i.selected) product.notes += "<br>No " + i.name;
          }
        }
        request.products.push(product);
        request.total += parseFloat(product.price) * parseInt(p.qty);
      }

      if (waiterSettings.thermal_printer_id) {
        request.thermal_printer_id = waiterSettings.thermal_printer_id;
        request.prebill_request = 1;
        request.prebill_printed = 0;
      }

      const response = await Api.postProtected("/orders/add/", request);
      if (response.success == 0) {
        alert(response.error);
      } else {
        emptyCart();
        setMaxFlow(getBaseFlowsNumber());
        setFlow(1);
        setCartVisible(false);
      }
    } catch (err) {
      alert("Error: " + err);
    } finally {
      orderSubmitInFlightRef.current = false;
      setLoading(false);
    }
  };

  const updateOrderFromCart = async () => {
    console.log("updateOrderFromCart");
    if (orderSubmitInFlightRef.current) return;
    orderSubmitInFlightRef.current = true;

    try {
      let order = {
        covers: cart.covers,
        total: 0,
        notes: cart.notes,
        products: [],
      };

      for (const p of cart.products) {
        const [variants, variantsPrice] = formatVariants(p.selectedVariants);
        const [subproducts, subproductsPrice] = formatProducts(p.selectedVariants);
        order.products.push({
          id: p.item_id,
          product_id: p.id,
          name: p.name,
          qty: p.qty,
          price: p.price,
          notes: p.notes ? p.notes : null,
          flow: p.flow,
          variants: variants,
          products: subproducts,
        });
        order.total += (parseFloat(p.price) + variantsPrice + subproductsPrice) * parseInt(p.qty);
      }

      if (waiterSettings.thermal_printer_id) {
        order.thermal_printer_id = waiterSettings.thermal_printer_id;
        order.prebill_request = 1;
        order.prebill_printed = 0;
      }

      setLoading(true);
      const res = await Api.postProtected("/orders/edit/" + cart.order_id + "/", order);
      if (res.success == 1) {
        initCart();
        setMaxFlow(getBaseFlowsNumber());
        setFlow(1);
        setCartVisible(false);
      } else {
        alert(res.error);
      }
    } catch (err) {
      alert("Error: " + err);
    } finally {
      orderSubmitInFlightRef.current = false;
      setLoading(false);
    }
  };

  const formatVariants = (selectedVariants) => {
    let price = 0;
    const response = [];
    if (selectedVariants !== false) {
      for (const vc of normalizeSelectedVariants(selectedVariants)) {
        for (const key of ["variants", "variants2"]) {
          for (const v of getSelectedVariantItems(vc, key)) {
            if (v.qty > 0 || (key === "variants2" && vc.force_mono == 1)) {
              let variant = {
                variant_category_id: vc.id,
                variant_id: v.id,
                name: v.name,
                qty: v.qty,
                price: v.price,
              };
              response.push(variant);
              price += parseFloat(v.price) * parseInt(v.qty);
            }
          }
        }
      }
    }
    return [response, price];
  };

  const formatProducts = (selectedVariants) => {
    let price = 0;
    const response = [];
    if (selectedVariants !== false) {
      for (const vc of normalizeSelectedVariants(selectedVariants)) {
        for (const key of ["products", "products2"]) {
          for (const v of getSelectedVariantItems(vc, key)) {
            if (v.qty > 0) {
              let subproduct = {
                variant_category_id: vc.id,
                product_id: v.id,
                name: v.name,
                qty: v.qty,
                price: v.price,
              };
              response.push(subproduct);
              price += parseFloat(v.price) * parseInt(v.qty);
            }
          }
        }
      }
    }
    return [response, price];
  };

  async function editOrder(id, request) {
    console.log("editOrder");
    setLoading(true);
    const response = await Api.postProtected("/orders/edit/" + id + "/", request);
    setLoading(false);
    if (response.success == 0) {
      alert(response.error);
    }
  }

  const editTable = async (request) => {
    console.log("editTable");
    setLoading(true);
    await Api.postProtected("/tables/edit/" + table.id + "/", request);
  };

  const lockTable = async () => {
    console.log("lockTable");
    setAlertData({
      title: "Sei sicuro?",
      message: "",
      showCancelButton: true,
      callback: async function () {
        setPopupVisible(false);
        editTable({ status: 2 });
        setTable(false);
      },
    });
  };

  const findIndex = (arr, srcParam, srcValue) => {
    let i = 0;
    for (const el of arr) {
      if (el[srcParam] == srcValue) return i;
      i++;
    }
    return false;
  };

  const checkIfProductExist = (products, newProduct, flow) => {
    let i = 0;
    for (const product of products) {
      let exist = false;

      if (
        product.id == newProduct.id &&
        product.flow == flow &&
        product.notes == newProduct.notes &&
        JSON.stringify(product.selectedVariants) === JSON.stringify(newProduct.selectedVariants) &&
        JSON.stringify(product.selectedIngredients) === JSON.stringify(newProduct.selectedIngredients)
      )
        exist = true;

      console.log(product.id, newProduct.id, product.flow, flow, exist);

      if (exist) return i;

      i++;
    }
    return false;
  };

  function filterMenu() {
    console.log("filterMenu", shop, list);
    let res = [];
    for (const course of menu) {
      const cr = structuredClone(course);
      cr.categories = [];
      for (const category of course.categories) {
        if (!category.hasOwnProperty("active_pos") || category.active_pos == 1) {
          const ct = structuredClone(category);
          if (shop && list) {
            ct.products = [];
            for (const product of category.products) {
              let p = filterVariants(product);
              p.stock = getProductStock(product.id);
              const priceList = product.prices.filter((el) => {
                return el.list_id == list.id && el.price;
              });
              const assortment = product.assortment.filter((el) => {
                return el.shop_id == shop.id && el.list_id == list.id && el.active == 1;
              });
              if (priceList.length > 0 && assortment.length > 0 && check_ingredients_assortment(product)) {
                p.price = priceList[0].price;
                ct.products.push(p);
              }
            }
            if (ct.products.length > 0) cr.categories.push(ct);
          } else if (shop) {
            ct.products = [];
            for (const product of category.products) {
              let p = filterVariants(product);
              p.stock = getProductStock(product.id);
              if (check_ingredients_assortment(product)) {
                ct.products.push(p);
              }
            }
            if (ct.products.length > 0) cr.categories.push(ct);
          } else {
            if (category.products.length > 0) cr.categories.push(category);
          }
        }
      }
      if (cr.categories.length > 0) res.push(cr);
    }
    setCourses(res);
    if (!category && res.length > 0 && res[0].categories.length > 0) setCategory(res[0].categories[0]);
    if (category) {
      const i = res.findIndex((vc) => {
        const cat = vc.categories.filter((c) => {
          return c.id == category.id;
        });
        return cat.length > 0;
      });

      if (i > -1) {
        const n = res[i].categories.findIndex((c) => c.id == category.id);
        if (n > -1) setCategory(res[i].categories[n]);
        else setCategory(res[0].categories[0]);
      } else if (res.length == 0) setCategory({ categories: [] });
      else setCategory(res[0].categories[0]);
    }
  }

  const filterVariants = (product) => {
    let p = JSON.parse(JSON.stringify(product));
    p.variants_categories = [];
    for (const variants_category of product.variants_categories) {
      if (
        variants_category.origins &&
        variants_category.origins.length > 0 &&
        !variants_category.origins.find((origin) => origin == "waiter")
      )
        continue;
      let vc = JSON.parse(JSON.stringify(variants_category));
      vc.variants = [];
      vc.variants2 = [];
      vc.products = [];
      vc.products2 = [];
      for (const variant of variants_category.variants) {
        let v = JSON.parse(JSON.stringify(variant));
        if (shop && list.id) {
          const priceList = variant.prices.filter((el) => {
            return el.list_id == list.id && el.price !== null;
          });
          const assortment = variant.assortment.filter((el) => {
            return el.shop_id == shop.id && el.list_id == list.id && el.active == 1;
          });
          if (priceList.length > 0 && assortment.length > 0) {
            v.price = priceList[0].price;
            vc.variants.push(v);
          }
        } else {
          vc.variants.push(v);
        }
      }
      for (const variant of variants_category.variants2) {
        let v = JSON.parse(JSON.stringify(variant));
        if (shop && list.id) {
          const priceList = variant.prices.filter((el) => {
            return el.list_id == list.id && el.price !== null;
          });
          const assortment = variant.assortment.filter((el) => {
            return el.shop_id == shop.id && el.list_id == list.id && el.active == 1;
          });
          if (priceList.length > 0 && assortment.length > 0) {
            v.price = priceList[0].price;
            vc.variants2.push(v);
          }
        } else {
          vc.variants2.push(v);
        }
      }
      for (const variant of variants_category.products) {
        let v = JSON.parse(JSON.stringify(variant));
        if (shop && list.id) {
          const priceList = variant.prices.filter((el) => {
            return el.list_id == list.id && el.price !== null;
          });
          const assortment = variant.assortment.filter((el) => {
            return el.shop_id == shop.id && el.list_id == list.id && el.active == 1;
          });
          if (priceList.length > 0 && assortment.length > 0 && check_ingredients_assortment(variant)) {
            v.price = priceList[0].price;
            vc.products.push(v);
          }
        } else if (shop) {
          if (check_ingredients_assortment(variant)) {
            vc.products.push(v);
          }
        } else {
          vc.products.push(v);
        }
      }
      for (const variant of variants_category.products2) {
        let v = JSON.parse(JSON.stringify(variant));
        if (shop && list.id) {
          const priceList = variant.prices.filter((el) => {
            return el.list_id == list.id && el.price !== null;
          });
          const assortment = variant.assortment.filter((el) => {
            return el.shop_id == shop.id && el.list_id == list.id && el.active == 1;
          });
          if (priceList.length > 0 && assortment.length > 0 && check_ingredients_assortment(variant)) {
            v.price = priceList[0].price;
            vc.products2.push(v);
          }
        } else if (shop) {
          if (check_ingredients_assortment(variant)) {
            vc.products2.push(v);
          }
        } else {
          vc.products2.push(v);
        }
      }
      if (
        vc.variants.length > 0 ||
        vc.variants2.length > 0 ||
        vc.products.length > 0 ||
        vc.products2.length > 0
      )
        p.variants_categories.push(vc);
    }
    return p;
  };

  const check_ingredients_assortment = (product) => {
    if (!settings.menu_api) return true;
    if (!settings.menu_api.enable_ingredients_assortment) return true;
    if (settings.menu_api.enable_ingredients_assortment != 1) return true;
    if (!product.ingredients) return true;
    if (product.ingredients.length == 0) return true;
    for (const ingredient of product.ingredients) {
      const assortment = ingredient.assortment.filter((el) => {
        return el.shop_id == shop.id && el.active == 1;
      });
      if (assortment.length == 0) return false;
    }
    return true;
  };

  const getProductStock = (productId) => {
    const s = stock.find((e) => e.product_id == productId && e.shop_id == shop.id);
    if (s) return s.qty;
    return false;
  };

  // rilegge lo stato di licenza del negozio quando puo' essere cambiato (socket, riconnessione,
  // ritorno in primo piano, cambio giorno) invece di fare polling
  const shopRef = useRef(false);
  useEffect(() => {
    shopRef.current = shop;
  }, [shop]);

  async function refreshShopLicense() {
    const current = shopRef.current;
    if (!current) return;
    try {
      const response = await Api.post("/shops/get/" + current.id + "/");
      const fresh = response && response.data;
      if (!fresh) return;
      setShop((prev) => {
        if (!prev || prev.id != fresh.id) return prev;
        if (prev.license_expired === fresh.license_expired && prev.license_notice === fresh.license_notice)
          return prev;
        return {
          ...prev,
          license_expires_at: fresh.license_expires_at,
          license_expire_date: fresh.license_expire_date,
          license_diff_days: fresh.license_diff_days,
          license_expired: fresh.license_expired,
          license_threshold: fresh.license_threshold,
          license_source: fresh.license_source,
          license_notice: fresh.license_notice,
        };
      });
    } catch (error) {
      console.error("License refresh error:", error);
    }
  }

  useEffect(() => {
    if (!user || !shop) return;

    let timer;
    const scheduleMidnightRefresh = () => {
      const now = new Date();
      const nextMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 5);
      timer = setTimeout(() => {
        refreshShopLicense();
        scheduleMidnightRefresh();
      }, nextMidnight - now);
    };
    const onVisibilityChange = () => {
      if (document.visibilityState === "visible") refreshShopLicense();
    };

    scheduleMidnightRefresh();
    document.addEventListener("visibilitychange", onVisibilityChange);
    return () => {
      clearTimeout(timer);
      document.removeEventListener("visibilitychange", onVisibilityChange);
    };
  }, [user, shop && shop.id]);

  // il banner di avviso licenza e' chiudibile ma riappare a ogni nuova sessione
  useEffect(() => {
    if (!user) setDismissedLicenseNotice(false);
  }, [user]);

  const licenseExpiredShop = !!(user && shop && shop.license_expired);
  const licenseNoticeKey = shop ? shop.id + ":" + shop.license_threshold : null;
  const licenseNoticeVisible =
    !!user && !!shop && !shop.license_expired && !!shop.license_notice && dismissedLicenseNotice !== licenseNoticeKey;

  // il banner e' fisso in alto: lascia spazio al layout invece di coprire l'header
  useEffect(() => {
    const root = document.getElementById("root");
    if (!root) return;
    root.classList.toggle("has-license-notice", licenseNoticeVisible);
    return () => root.classList.remove("has-license-notice");
  }, [licenseNoticeVisible]);

  function handleSocketEvent(type, data) {
    console.log("handleSocketEvent", type);
    if (type == "socket_connected") refreshShopLicense();
    if (type == "shops") {
      const current = shopRef.current;
      if (current && (!data || !data.id || String(data.id) === String(current.id))) refreshShopLicense();
    }
    if (type == "settings") load_settings();
    if (type == "rooms") loadRooms();
    if (type == "tables") loadTables();
    if (type == "menu") loadMenu();
    if (type == "products_stock") loadStock();
    if (type == "orders") {
      //loadOrders();
      loadTables();
    }
    if (type == "thermal_printers") loadThermalPrinters();
  }

  return (
    <>
      {settings && shop && (
        <Socket
          socket={socket}
          mandantId={settings.mandant.id}
          onMessage={handleSocketEvent}
          shop={shop}
          settings={settings}
          config={config}
        />
      )}
      {loaded ? (
        <MainContext.Provider
          value={{
            settings,
            loading,
            shop,
            setShop,
            list,
            table,
            setTable,
            popupVisible,
            setPopupVisible,
            popupData,
            setPopupData,
            category,
            setCategory,
            courses,
            addProduct,
            saveProduct,
            emptyCart,
            editQty,
            editFlow,
            checkout,
            setLoading,
            alertData,
            setAlertData,
            handleAddProduct,
            variantsPopup,
            setVariantsPopup,
            toast,
            setToast,
            menuVisible,
            setMenuVisible,
            user,
            setUser,
            menu,
            findIndex,
            cart,
            setCart,
            flow,
            setFlow,
            maxFlow,
            setMaxFlow,
            editTable,
            tables,
            rooms,
            setCartVisible,
            lockTable,
            animations,
            setAnimations,
            initCart,
            tempTable,
            setTempTable,
            lists,
            setTableEditPopup,
            ordersDisabled,
            shops,
            setQrPopupVisible,
            setQrPopupCloseToTables,
            closeQrPopup,
            editOrder,
            openOrder,
            updateOrderFromCart,
            thermalPrinters,
            waiterSettings,
            setWaiterSettings,
          }}
        >
          {!user ? (
            isTabletEmbed ? (
              <Loading />
            ) : (
              <Login />
            )
          ) : (
            <>
              {shop && table && (
                <div className="main order-screen">
                  <Header />
                  <div className="content">
                    {settings.waiter_app.categories_menu_type == 2 && <CategoriesSelect />}
                    {(!settings.waiter_app.categories_menu_type ||
                      settings.waiter_app.categories_menu_type == 1) &&
                      category && (
                        <div className="category-title with-flow">
                          <FlowModeSelector className="in-category-title" />
                          <div>{category.name.toUpperCase()}</div>
                        </div>
                      )}

                    {src && (
                      <div className="category-title search-results-title">Risultati della ricerca</div>
                    )}
                    <Products />
                  </div>
                  <Footer />
                </div>
              )}
              {shop && !table && <Tables />}
              {tableEditPopup && (
                <>
                  <div className="overlay" onClick={() => setTableEditPopup(false)}></div>
                  <TableEditPopup />
                </>
              )}
              {cartVisible && (
                <>
                  <div className="overlay" onClick={() => setCartVisible(false)}></div>
                  <Cart />
                </>
              )}
              {menuVisible && <Menu />}
              {variantsPopup && (
                <>
                  <div className="overlay" onClick={() => setVariantsPopup(false)}></div>
                  <VariantsPopup />
                </>
              )}
              {popupVisible && (
                <>
                  <div className="overlay" onClick={() => setPopupVisible(false)}></div>
                  {popupVisible == "covers" && <Covers />}
                  {popupVisible == "history" && <HistoryPopup />}
                  {popupVisible == "orderNotes" && <OrderNotes />}
                  {popupVisible == "productNotes" && <ProductNotes />}
                  {popupVisible == "priceEdit" && <PriceEditPopup />}
                  {popupVisible == "settings" && <Settings />}
                </>
              )}
              {qrPopupVisible && (
                <>
                  <div className="overlay" onClick={closeQrPopup}></div>
                  <QrPopup />
                </>
              )}
              {!shop && !isTabletEmbed && <Shops />}
            </>
          )}
          {alertData && <Alert />}
          {loading && <Loading />}
          <Toast />
          {licenseNoticeVisible && (
            <div className="license-notice">
              <span title={shop.license_notice}>{shop.license_notice}</span>
              <button type="button" aria-label="Chiudi" onClick={() => setDismissedLicenseNotice(licenseNoticeKey)}>
                ×
              </button>
            </div>
          )}
          {licenseExpiredShop && (
            <div className="expire">
              <div className="content">
                <h3>ATTENZIONE</h3>
                Licenza del negozio {shop.name} scaduta da {Math.abs(parseInt(shop.license_diff_days) || 0)}{" "}
                {Math.abs(parseInt(shop.license_diff_days) || 0) == 1 ? "giorno" : "giorni"}
                <br /> Per il rinnovo dei servizi contatta il commerciale di riferimento
                <button
                  type="button"
                  className="btn btn-primary btn-block"
                  onClick={() => {
                    localStorage.removeItem("waiter-user");
                    setTable(false);
                    setShop(false);
                    setUser(false);
                  }}
                >
                  Esci e cambia negozio
                </button>
              </div>
            </div>
          )}
        </MainContext.Provider>
      ) : (
        <Loading />
      )}
    </>
  );
}

function getSocketUrl() {
  const hostname = window.location.hostname;
  let socketUrl;
  if (hostname.includes("localhost") || hostname.includes(".dev.") || hostname.includes(".demo."))
    socketUrl = "https://ws.dev.yellgo.cloud:3000";
  else socketUrl = "https://ws.yellgo.cloud";
  return socketUrl;
}

export default App;
